module.exports = __webpack_public_path__ + "static/media/fullsummary.e5e5406d.pdf";